import { changePasswordService } from '@afterpaytouch/portal-api/consumer/account/change-password'

export const { useChangePasswordMutation } = changePasswordService
